var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "window" },
    [
      _c(
        "navigation-bar",
        [
          _c("navigation-link", {
            attrs: {
              exact: true,
              icon: "icon_search",
              label: "Domains",
              to: { name: "domain-search" }
            }
          }),
          _vm._v(" "),
          _c("navigation-link", {
            attrs: {
              label: "News",
              icon: "icon_messages",
              to: { name: "news" }
            }
          }),
          _vm._v(" "),
          _c("navigation-link", {
            attrs: { label: "Help", icon: "icon_help", to: { name: "help" } }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("router-view", {
        attrs: { name: "domain-search" },
        on: {
          onNotification: _vm.onNotification,
          onWorkflowHistoryEventParamToggle:
            _vm.onWorkflowHistoryEventParamToggle
        }
      }),
      _vm._v(" "),
      _c("router-view", {
        attrs: { name: "help" },
        on: { onNotification: _vm.onNotification }
      }),
      _vm._v(" "),
      _c("router-view", {
        attrs: { name: "news" },
        on: { onNotification: _vm.onNotification }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-174b46f3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-174b46f3","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/routes/index.vue
// module id = 1729
// module chunks = 0